import { useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { CollabStateContext } from 'stores/CollabState'
import { ConnectionStatus, StateSyncStatus } from './utils'
import { PortalToolbarOverlay } from './ToolbarOverlay'
import { PortalOfflineOverlay } from './OfflineOverlay'

export const StatusOverlay = observer(function StatusOverlay() {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const { saveStatus, connStatus } = useContext(CollabStateContext)!

  const showSavingOverlay = connStatus === ConnectionStatus.LongConnecting && saveStatus === StateSyncStatus.Behind
  const showOfflineOverlay = connStatus === ConnectionStatus.LongConnecting && saveStatus !== StateSyncStatus.Behind

  return (
    <>
      {showSavingOverlay && <PortalToolbarOverlay />}
      {showOfflineOverlay && <PortalOfflineOverlay />}
    </>
  )
})
